module.exports = __webpack_public_path__ + "img/title2.9a169652.png";